import REST_CLIENT from '../utils/restClient';

const API = {
    doRetrieveLicenseKey: () => {
        return async () => {
            const response = await REST_CLIENT.getApiLicenseKey();
            return {
                licenseKey: response?.licenseKey,
                customerId: response?.customerId
            };
        };
    },
};

export default API;
